import React from 'react';
import * as C from '../common-styles.styles';
import * as S from './list-for-links.styles';

const SrcDestDistance = props => {
  const { title, aerial_distance, road_distance, isDweb = false } = props;

  return (
    <C.Wrap isDweb={isDweb}>
      <S.Details>
        <h3>{title}</h3>
        {aerial_distance && road_distance && (
          <S.Content>
            <S.Left>
              <div className="aerial_distance">Aerial distance</div>
              <div className="road_distance">Road distance</div>
            </S.Left>
            <S.Right>
              <div className="aerial_km">{aerial_distance} Km</div>
              <div className="road_km">{road_distance} Km</div>
            </S.Right>
          </S.Content>
        )}
      </S.Details>
    </C.Wrap>
  );
};

export default SrcDestDistance;
